import { IconButton, Stack, TextField, Typography } from "@mui/material";
import { colors } from "colors";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { codeEditorActions } from "store/codeEditor";
import SendIcon from "@mui/icons-material/Send";
import StopCircleIcon from "@mui/icons-material/StopCircle";

export default function PromptInput({ handleSend }) {

  const dispatch = useDispatch();
  const [shiftOn, setShiftOn] = useState(false);
  const prompt = useSelector((state) => state.codeEditor.prompt);
  const sending = useSelector((state) => state.codeEditor.sending);

  const disabled = () => {
    if (shiftOn) return true;
    if (sending) return true;
    return !Boolean(prompt);
  };

  const handleKeyDown = (event) => {
    if (disabled()) return;
    setShiftOn(Boolean(event.shiftKey));
    // Only send the message if composition is not active
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      handleSend(prompt);
    }
  };

  const handleKeyUp = (event) => {
    setShiftOn(Boolean(event.shiftKey));
  };

  const renderSendButton = () => {
    if (sending) {
      const cancelDisabled = false;
      return (
        <IconButton
          color="primary"
          //onClick={handleCancel}
          //disabled={cancelDisabled}
          data-testid="code-editor-cancel-button"
        >
          <StopCircleIcon
            sx={{ color: colors.white, opacity: cancelDisabled ? 0.25 : 1 }}
          />
        </IconButton>
      );
    }
    const sendDisabled = false;
    return (
      <IconButton
        color="primary"
        //onClick={handleSendMessage}
        //disabled={isDisabled}
        data-testid="code-editor-send-button"
        onClick={() => handleSend(prompt)}
      >
        <SendIcon
          sx={{ color: colors.white, opacity: sendDisabled ? 0.25 : 1 }}
        />
      </IconButton>
    );
  };

  return (
    <Stack>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        justifyContent="center"
      >
        <TextField
          fullWidth
          sx={{
            maxWidth: "600px",
          }}
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyUp}
          placeholder="How can I help you?..."
          data-testid="code-editor-prompt-input"
          value={prompt}
          onInput={(event) =>
            dispatch(codeEditorActions.setPrompt(event.target.value))
          }
          multiline
          maxRows={6}
          disabled={sending}
          InputProps={{
            style: {
              backgroundColor: colors.drakGray,
              color: colors.white,
            },
          }}
        />
        {renderSendButton()}
      </Stack>
      <Typography
        variant="caption"
        sx={{
          color: colors.white,
        }}
        textAlign="center"
      >
        AI can make mistakes. Check important information.
      </Typography>
    </Stack>
  );
}
